import { DesignSystem } from '@adornis/chemistry/elements/theming/design.js';
import type { Renderable } from '@adornis/chemistry/renderable.js';
import { assembleMailTemplate } from '@adornis/mails/db/mail-template.js';
import type { BuildEmailOptions } from '@adornis/mails/db/templates.js';
import type { BuddyMailTemplate } from '../entities/mail-templates.js';

const colorConfig = {
  mainBorder: 'none',
  mainBack: DesignSystem.currentTheme.getValue().colors.neutral.shade(50),
  wrapperBack: 'transparent',
};

export async function assembleBuddyMail(options: {
  template: BuddyMailTemplate;
  infos?: Record<string, string | undefined>;
  overrides?: Partial<BuildEmailOptions>;
}): Promise<{ subject: string; content: Renderable }> {
  const { template, infos, overrides } = options;

  return assembleMailTemplate({
    template: template.toJSON(),
    infos,
    overrides: {
      title: 'Buchungsheld Benachrichtigungsmail',
      // The legacy renderer ignores template logo/colour fields and replaces the static footer
      // with the template footer, the caller's footer, or an empty string.
      logoConfig: undefined,
      colorConfig,
      footer: '',
      ...overrides,
    },
    // Empty bodies remain absent even when the caller supplies contents.
    ...(template.content ? {} : { renderFunction: () => '' }),
  });
}
